<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<rtn-part-mst-search ref="RtnPartMstSearch" 
						:scrId="scrId"
						:pStartDt="pStartDt"
						:pEndDt="pEndDt"
						:pState1="pState1"
						:pState2="pState2"
						:pState3="pState3"
					></rtn-part-mst-search>
				</sf-card>
			</div>

			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<rtn-part-mst-table ref="table" @registerRtnPart="registerRtnPart" :scrId="scrId"  @Refresh="Refresh"/>
				</sf-card>
			</div>

			<rtn-part-mst-popup ref="popup" :scrId="scrId" @Refresh="Refresh"></rtn-part-mst-popup>
		</div>
	</div>
</template>

<script>
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../store/helpers';
import RtnPartMstSearch from './Search/RtnPartMstSearch.vue';
import RtnPartMstTable from './Table/RtnPartMstTable.vue';
import RtnPartMstPopup from './Popup/RtnPartMstPopup.vue';

export default {
	props: {
		scrId: { type: String, default: '' },
		pStartDt: { type: String, default: '' }, //클레임 승인현황에서 시작일자 가져옴
		pEndDt: { type: String, default: '' }, //클레임 승인현황에서 종료일자 가져옴
		pState1: { type: String, default: '' }, //클레임 승인현황에서 처리단계 가져옴
		pState2: { type: String, default: '' }, //클레임 승인현황에서 처리결과 가져옴
		pState3: { type: String, default: '' }, //클레임 승인현황에서 날짜 검색조건 가져옴
	},
	components: {
		RtnPartMstSearch,
		RtnPartMstTable,
		RtnPartMstPopup
	},
	async created() {
		try {
			this.setState_({key: 'isMqyStation', value: await this.inclManyUsrGrp_(['MQYSS'])});
			// console.log('-----',this.isMqyStation);
		} catch (error) {
			this.$sf_toast({ type: 'error', message: error?.message || error });
		} finally {
			this.$sf_toggleLoading(false);
		}
	},
	computed: {
		...qmsComputed,
		...rootComputed,
		...serviceComputed
	},
	components: {
		RtnPartMstSearch,
		RtnPartMstTable,
		RtnPartMstPopup
	},
	methods: {
		...qmsMethods,
		...rootMethods,
		...serviceMethods,
		Refresh() {
			this.$refs.RtnPartMstSearch.searchList();
		},
		registerRtnPart(param) {
			this.$refs.popup.open(param);
		}
	}
};
</script>

<style></style>
